import e from"react";import a from"./Sidebar.styles.js";const s=({children:s,className:r})=>e.createElement("div",{className:a.header({className:r})},s);export{s as default};
